<template>
    <section class="textSection">
        <h1>Questionnaire : SUJET</h1>
        <p>instructions d'utilisation</p>
        <form>
            <fieldset>
                <legend>Question numéro X</legend>
                <p>Intitulé de la question </p>
                <input type="checkbox" name="reponseA" id="answer"/> :  <label for="answer">reponse</label>
            </fieldset>
        </form>
        <input type="submit" value="Valider"/>
        <input type="reset" value="Réinitialiser"/>
    </section>
</template>

<script>
    export default {
        name: 'form'
    }
</script>

<style> 

</style>



// WEBPACK FOOTER //
// Form.vue?6887a203